<template>
  <div id="app">
    <layout></layout>
    <!-- <img src="./assets/logo.png"> -->
    <!-- <keep-alive>
      <router-view style="min-height:630px" v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>-->
    <router-view style="min-height:630px"></router-view>
    <!-- <router-view/> -->
    <footerbar v-show="showfooter"></footerbar>
  </div>
</template>

<script>
import footerbar from "@/views/footerbar/footerbar";
import signature from "@/utils/signature";
import Layout from "@/views/Layout";
import { getInitTime } from "@/api/getTime";
import store from "@/store";
export default {
  name: "App",
  data() {
    return {
      showfooter: true
    };
  },
  watch: {
    "$store.state.showFooter": "setfo"
  },
  components: {
    footerbar,
    Layout
  },
  beforeCreate() {
    if (
      navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    ) {
      window.location.href = "/mobile/index.html#/";
    } else {
      window.location.href = "/dist/index.html#/";
    }
  },
  created() {
    // this.getServerTime();
    // this.setHdr();
  },
  methods: {
    setfo() {
      console.log(this.showfooter);
      this.showfooter = this.$store.state.showFooter;
    },
    getServerTime() {
      getInitTime().then(response => {
        let serTime = response.data.mtime;
        let locTime = Date.parse(new Date());
        let timeGap = serTime - locTime;
        this.$store.commit("setTimeGap", timeGap);
      });
    },
    setHdr() {
      let hdLocTime = Date.parse(new Date());
      let timeStamp = hdLocTime + this.$store.state.timeGap;
      let plf = "email";
      let signData = "token=&platform=" + plf + "&time=" + timeStamp;
      let signa = signature.Encrypt(signData);
      let designa = signature.Decrypt(signa);
      this.$store.commit("setHeader", signa);
    }
  }
};
</script>

<style>
@import "./css/public.css";
#app {
}
* {
  margin: 0;
  padding: 0;
}
html,
body {
  background: #f8f8f8;
  height: 100%;
}
/* .element {
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
}
.element::-webkit-scrollbar {
  width: 0 !important;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue